import React, { Component, Fragment } from 'react';

import Project from '../Project/Project';
import projects from '../../data/projects';

export default class Portfolio extends Component {

  render() {
    return (
      <Fragment>
        <h3 className="text-white">Portfolio</h3>
        { projects.map((project, index) => <Project key={index} project={ project } />) }
      </Fragment>
    );
  }

}



// WEBPACK FOOTER //
// ./src/components/Portfolio/Portfolio.js